import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Menu, Button, Icon, Input, Responsive } from 'semantic-ui-react';
import i18next from 'i18next';
import MenuCategory from './MenuCategory';
import { setEditedEntity } from '../../../actions';

const getListStyle = (isDraggingOver) => ({
    // background: isDraggingOver ? "#ececec" : "lightgrey",
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 10,
    flex: 1,
    height: '100%',
    overflowY: 'auto'
});

class Subcategories extends Component {
    state = {
        currentType: 'subcategories',
        show: window.innerWidth > Responsive.onlyMobile.maxWidth,
        searchTerm: ''
    }

    render() {
        const re = new RegExp(_.escapeRegExp(this.state.searchTerm), 'i');

        const categories = this.props.categories.filter(cat => {
            const isMatch = re.test(cat.name) || re.test(cat.key) || re.test(cat.note || '');
            if (!isMatch) return false;

            switch (this.state.currentType) {
                case 'upsells':
                    return cat.type === 'upsell';
                case 'announcements':
                    return cat.type === 'announcement';
                default:
                    return !['announcement', 'upsell'].includes(cat.type);
            }
        });

        return (
            <div style={{ display: 'flex', background: 'rgba(0,0,0,.05)' }}>
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.setState({ show: !this.state.show })}>
                    <div style={{ width: 1, height: '100%', background: 'rgba(34,36,38,.15)' }} />
                    <Icon name={this.state.show ? 'triangle left' : 'triangle right'} size="big" style={{ marginLeft: -4, marginRight: -4, transform: `rotate(${i18next.dir() === 'ltr' ? '180deg' : 0})` }} />
                    <div style={{ width: 1, height: '100%', background: 'rgba(34,36,38,.15)' }} />
                </div>
                <div style={{ display: this.state.show ? 'flex' : 'none', flexDirection: 'column', width: 340 }}>
                    <Menu widths={2} style={{ marginBottom: 0 }}>
                        <Menu.Item
                            style={{ width: '33.33%' }}
                            name={i18next.t('menu.subcategories')}
                            active={this.state.currentType === 'subcategories'}
                            onClick={() => this.setState({ currentType: 'subcategories' })}

                        />
                        <Menu.Item
                            style={{ width: '33.33%' }}
                            name={i18next.t('menu.upsells.title')}
                            active={this.state.currentType === 'upsells'}
                            onClick={() => this.setState({ currentType: 'upsells' })}
                        />
                        <Menu.Item
                            style={{ width: '33.33%' }}
                            name={i18next.t('menu.announcements.title')}
                            active={this.state.currentType === 'announcements'}
                            onClick={() => this.setState({ currentType: 'announcements' })}
                        />
                    </Menu>
                    <Menu style={{ margin: 0, background: 'transparent', border: 'none', boxShadow: 'none', padding: 8 }}>
                        <Input
                            fluid
                            placeholder={i18next.t('search')}
                            value={this.state.searchTerm}
                            onChange={({ target }) => this.setState({ searchTerm: target.value })}
                            style={{ width: '60%', margin: 2 }}
                        />

                        <Button
                            content={i18next.t('newCategory')}
                            basic
                            onClick={() => this.props.setEditedEntity('menuCategory', { menuId: this.props.menuId, type: this.state.currentType === 'upsells' ? 'upsell' : this.state.currentType === 'announcements' ? 'announcement' : 'mandatory' })}
                            style={{ width: '40%', margin: 2 }}
                        />
                    </Menu>
                    <Droppable droppableId="subcategories" type="subcategory">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                <div>
                                    {categories.map((category, index) => (
                                        <MenuCategory
                                            key={category.id}
                                            category={category}
                                            handleSubcategoryClick={this.props.handleSubcategoryClick}
                                            branchIdForOverride={this.props.branchIdForOverride}
                                            index={index}

                                        />
                                    ))}
                                </div>
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </div>

            </div >
        );
    }
}

Subcategories.propTypes = {
    categories: PropTypes.array
};

export default connect(null, { setEditedEntity })(Subcategories);
